import "vue";
import { r as resolveActiveStatus, a as resolveContent, b as bind, c as resolveDirectiveProps, u as unbind } from "../../../floatingUi-BNsDDTHR.mjs";
import { d as defaultsKey } from "../../../keys-41Cw9q6f.mjs";
import { f as findProvides } from "../../../utils-DPq73bs8.mjs";
const vBPopover = {
  mounted(el, binding, vnode) {
    var _a;
    const defaults = (_a = findProvides(binding, vnode)[defaultsKey]) == null ? void 0 : _a.value;
    const isActive = resolveActiveStatus(binding.value);
    if (!isActive) return;
    const text = resolveContent(binding.value, el);
    if (!text.content && !text.title) return;
    el.$__binding = JSON.stringify([binding.modifiers, binding.value]);
    bind(el, binding, {
      ...defaults["BPopover"] || void 0,
      ...resolveDirectiveProps(binding, el),
      ...text
    });
  },
  updated(el, binding, vnode) {
    var _a;
    const defaults = (_a = findProvides(binding, vnode)[defaultsKey]) == null ? void 0 : _a.value;
    const isActive = resolveActiveStatus(binding.value);
    if (!isActive) return;
    const text = resolveContent(binding.value, el);
    if (!text.content && !text.title) return;
    delete binding.oldValue;
    if (el.$__binding === JSON.stringify([binding.modifiers, binding.value])) return;
    unbind(el);
    bind(el, binding, {
      ...defaults["BPopover"] || void 0,
      ...resolveDirectiveProps(binding, el),
      ...text
    });
    el.$__binding = JSON.stringify([binding.modifiers, binding.value]);
  },
  beforeUnmount(el) {
    unbind(el);
  }
};
export {
  vBPopover
};
//# sourceMappingURL=index.mjs.map
